import { Typography, LinearProgress, type LinearProgressProps } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './progress.module.css'

export interface ProgressProps extends LinearProgressProps {
  selected?: boolean
  value: number
}

const Progress: FC<ProgressProps> = props => (
  <div className={styles.container}>
    <LinearProgress
      variant="determinate"
      className={styles.progressBar}
      {...props}
    />
    <div className={styles.label}>
      <Typography variant="body2" color="textSecondary">{`${Math.round(props.value)}%`}</Typography>
    </div>
  </div>
)

export default Progress
